import Generic from "./generic";
import Logo from "./logo";
import LogoSmall from "./logo-small";

export default {
  generic: Generic,
  logo: Logo,
  "logo-small": LogoSmall,
};
